import { update } from 'perfect-scrollbar';
import apiService from './apiService.js';

const resource = '/delegations';

export default {
    getDelegations(currentPage, itemsPerPage, searchQuery) {
        return apiService.get(`${resource}`, {
            params: {
                page: currentPage,
                pageSize: itemsPerPage,
                search: searchQuery
            },
        });
    },
    canPersonBeDelegatedTo(personId) {
        return apiService.get(`${resource}/can-delegate/`, {
            params: {
                person_id: personId
            },
        });
    },
    getDelegatablePeople() {
        return apiService.get(`${resource}/delegatable-people`);
    },
    createDelegation(newDelegation) {
        return apiService.post(`${resource}`, {
            root_user_id: newDelegation.rootUserId,
            delegation_user_id: newDelegation.delegationUserId,
            expires_at: newDelegation.expiresAt
        });
    },
    updateDelegation(updatedDelegation) {
        return apiService.post(`${resource}/update`, {
            id: updatedDelegation.id,
            expires_at: updatedDelegation.expires_at
        });
    },
    deleteDelegation(delegationId) {
        return apiService.post(`${resource}/delete`, {
            id: delegationId
        });
    }
};
